import React from "react";
import { useState } from "react";
import { useEffect } from "react";

import { toast } from "@performyard/py-components";
import { Text as Typography } from "@performyard/py-components";
import { ButtonStandard } from "@performyard/py-components";

import Input from "../../../../../../components/Inputs/InputText";
import { FormModal } from "../../../../../../components/Modal/Templates/FormModal";

import { router } from "../../../../../../app/router";

import { SURVEY_DETAILS_MODALS } from "../../store/model";
import { useModal, useSetters } from "../../store/store";

import { useCopySurvey } from "../../../../../../api/hooks/defs/surveys";

import { formatErrorMessage } from "../../../../../../utils/TanstackQueryErrorHandling";

export const SaveAsCopyModal = ({ surveyId, surveyName }: { surveyId: string; surveyName: string }) => {
	const [name, setName] = useState<string>("");
	const [validationError, setValidationError] = useState<string>("");

	const modal = useModal();
	const setters = useSetters();

	// copy survey hook
	const onSuccess = async (data) => {
		setters.setModal(null);
		router.navigate(`/surveys/${data._id}?tab=build`);
	};

	useEffect(() => {
		if (modal === SURVEY_DETAILS_MODALS.SAVE_AS_COPY) {
			setName(`${surveyName} (Copy)`);
			setValidationError("");
		} else {
			setName("");
			setValidationError("");
		}
		return () => {
			setName("");
			setValidationError("");
		};
	}, [surveyName, modal]);

	const onError = async (error, variables) => {
		if (error.data?.message?.endsWith("Survey name must be unique")) {
			setValidationError("A survey with this name already exists");
		} else if (
			error.data?.message.includes("Validation failed.") &&
			error.data?.details?.includes("String must contain at most 250 character(s)")
		) {
			setValidationError("Max character count is 250");
		} else {
			//default error handling is turned off for this mutation
			const messages = formatErrorMessage(error, variables);

			messages.forEach((message) => {
				toast.error(message);
			});
			setters.setModal(null);
		}
	};
	const { mutate: copySurvey, isPending: isCopyingSurvey } = useCopySurvey({ onSuccess, onError });

	const handleClose = () => {
		setters.setModal(null);
		setName("");
		setValidationError("");
	};

	// copy survey modal
	return (
		<FormModal
			title={
				<Typography size="sub-heading" weight="semi-bold">
					Save Survey as Copy
				</Typography>
			}
			isOpen={modal === SURVEY_DETAILS_MODALS.SAVE_AS_COPY}
			buttons={[
				<div key="copy-survey-cancel">
					<ButtonStandard type="button" size="large" onClick={handleClose}>
						Cancel
					</ButtonStandard>
				</div>,
				<div key="copy-survey-submit">
					<ButtonStandard
						data-testid="save-as-copy-button"
						type="submit"
						size="large"
						color="green"
						disabled={isCopyingSurvey}
					>
						Save as Copy
					</ButtonStandard>
				</div>,
			]}
			handleClose={handleClose}
			onSubmit={(event) => {
				event.preventDefault();
				if (!name) {
					setValidationError("A survey name is required");
					return;
				}
				if (name.length > 250) {
					setValidationError("Max character count is 250");
					return;
				}
				copySurvey({ name, surveyId });
			}}
		>
			<Input
				testId="save-as-copy-input"
				label="Survey Name"
				value={name}
				onChange={(value) => {
					setValidationError("");
					setName(value);
				}}
				placeholder="New Survey Name"
				errorMessage={validationError}
			/>
		</FormModal>
	);
};
